import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { filter } from 'lodash';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import DealerAddress from './DealerAddress';
import BuyingSites from './BuyingSites';
import addressData from './addressData.json';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';
import logo from "../../resources/img/sentry-safe-logo.png";
import Link from "../common/TrackedLink";
import logo2x from "../../resources/img/sentry-safe-logo@2x.png";

class WhereToBuy extends Component {
	constructor(props) {
		super(props);
		this.state = {
			address: null
		};
	}

	handleChange(e) {
		let addresses = addressData;
		const element = e.target;
		addresses = filter(addresses, ['id', element.value]);
		if (addresses !== null) {
			const addressVal = addresses.map(
				(address,index) => <DealerAddress key={ index } address={ address } />
			);
			this.setState({
				address: addressVal
			});
		}
		global.dataLayer.push({
			event: 'Where to Buy',
			eventCategory: 'Where to Buy',
			eventAction: 'Dropdown',
			eventLabel: element.options[element.selectedIndex].text
		});
	}

	handleTabClick(e) {
		global.dataLayer.push({
			event: 'Where to Buy',
			eventCategory: 'Where to Buy',
			eventAction: 'Tabs',
			eventLabel: e.currentTarget.textContent
		});
	}

	render() {
		return (
			<div className="where-to-buy">
				<Helmet>
					<title>Where To Buy &#124; SentrySafe</title>
					<meta name="description" content="Our retailers offer a wide selection of SentrySafe products to meet your needs. Shop online or purchase in store with our preferred retailers." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Where to Buy" />
				</Breadcrumb>

				<header className="row header-callout">
					<div className="col">
						<h1>Where to Buy</h1>
						<p>Our retailers offer a wide selection of SentrySafe products to meet your needs. Browse our preferred retailers.</p>
					</div>
				</header>

				<section className="preferred-retailers">
					<div className="row">
						<div className="col">

							<h2 className="title">Buy Now From SentrySafe</h2>
							<div style={{"text-align": "center"}}>
								<br/>
								<Link
									to="https://store.sentrysafe.com/"
									target="_blank"
									trackEventCategory={"Where To Buy"}
									trackEvent={"Where To Buy"}
									trackEventAction={"Store.SentrySafe"}
									trackEventLabel={"/where-to-buy"}
								>
								<img
									src={ logo }
									srcSet={ `${logo2x} 2x`}
									alt="SentrySafe"
									style={{width: '200px'}}
								/>
								</Link><br/><br/>
								<hr style={{width: '200px'}}/>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<h2 className="title">Shop Our Preferred Retailers</h2>
							<Tabs>
								<TabList>
									<Tab onClick={ e => this.handleTabClick(e) }>
										United States
									</Tab>
									<Tab onClick={ e => this.handleTabClick(e) }>
										Canada
									</Tab>
									<Tab onClick={ e => this.handleTabClick(e) }>
										International Distributors & Agents
									</Tab>
								</TabList>
								<TabPanel>
									<BuyingSites region="United States" />
								</TabPanel>
								<TabPanel>
									<BuyingSites region="Canada" />
								</TabPanel>
								<TabPanel>
									<BuyingSites region="United Kingdom" />
									<div className="international-distributors">
										<div className="row">
											<div className="col">
												<p>
													If you are looking for a contact for one of our international distributors and agents,
													please select a territory from the list below, and a list of all of the pertinent
													contacts from that area will show up. Distributors and agents can provide a list of
													retailers who carry the SentrySafe products.
												</p>
												<label htmlFor="address" className="assistive-text">
													Select a Territory
												</label>
												<select
													className="address-list"
													id="address"
													name="address"
													onChange={ e => this.handleChange(e) }
												>
													<option value="">-- Select a Territory --</option>
													<option value="AL">Algeria</option>
													<option value="AN">Angola</option>
													<option value="ANP">Australia - New Zealand - Papua New Guinea - Fiji, Somoa - Tonga</option>
													<option value="BAH">Bahrain</option>
													<option value="CY">Cyprus</option>
													<option value="EG">Egypt</option>
													<option value="FR">France</option>
													<option value="GR">Greece</option>
													<option value="GM">Germany</option>
													<option value="HK">Hong Kong / Macau</option>
													<option value="ID">Indonesia</option>
													<option value="IS">Israel</option>
													<option value="JP">Japan</option>
													<option value="JD">Jordan</option>
													<option value="KU">Kuwait</option>
													<option value="LB">Lebanon</option>
													<option value="MR">Morocco</option>
													<option value="OM">Oman</option>
													<option value="PP">Philippines</option>
													<option value="QR">Qatar</option>
													<option value="RM">Rep. Of Maldives</option>
													<option value="SAU">Saudia Arabia</option>
													<option value="SMB">Singapore, Malaysia and Brunei</option>
													<option value="TW">Taiwan</option>
													<option value="TLM">Thailand, Laos &amp; Myanmar</option>
													<option value="UAE">UAE</option>
													<option value="UC">United States and Canada</option>
													<option value="VT">Vietnam</option>
												</select>
												{ this.state.address }
											</div>
										</div>
									</div>
								</TabPanel>
							</Tabs>
						</div>
					</div>
				</section>
			</div>
		);
	}
};

export default WhereToBuy;


// WEBPACK FOOTER //
// ./src/pages/whereToBuy/Index.js